import styled from "styled-components/macro";

export const Container = styled.div`
  // border: 1px solid black;

  table {
    margin-top: 20px;
    width: 400px;
    border-collapse: collapse;
  }
  th {
    text-align: left;
    border-bottom: 1px solid black;
  }

  .test-run-button {
    background: unset !important;
    color: black !important;
    border: 1px solid black !important;
    padding: 1px !important;
    border-radius: unset !important;
    margin-left: 10px !important;
    padding-left: 5px !important;
    padding-right: 5px !important;
  }
`;
